import PropTypes from "prop-types";
import { Button, Tooltip } from "antd";
import { PlayCircleOutlined } from "@ant-design/icons";
import { useState } from "react";

import { useCustomToolStore } from "../../store/custom-tool-store";
import { promptRunSps } from "./simple-prompt-studio-api-service";
import { useAlertStore } from "../../store/alert-store";
import { useExceptionHandler } from "../../hooks/useExceptionHandler";
import { indexStatuses } from "./helper";
import { RecaptchaModal } from "../recaptcha/RecaptchaModal";

function PromptRunBtnSps({
  spsLoading,
  handleSpsLoading,
  handleGetOutput,
  promptDetails,
}) {
  const [openCaptchaModal, setOpenCaptchaModal] = useState(false);
  const { details, selectedDoc } = useCustomToolStore();
  const { setAlertDetails } = useAlertStore();
  const handleException = useExceptionHandler();

  const promptRunValidation = () => {
    if (selectedDoc?.index_status !== indexStatuses.success) {
      setAlertDetails({
        type: "error",
        content: "Document needs to be index before running the prompt",
      });
      return;
    }

    if (!promptDetails?.prompt_key) {
      setAlertDetails({
        type: "error",
        content: "Field name cannot be empty",
      });
      return;
    }

    if (!promptDetails?.prompt) {
      setAlertDetails({
        type: "error",
        content: "Prompt cannot be empty",
      });
      return;
    }

    setOpenCaptchaModal(true);
  };

  const handleRunPromptSps = (token) => {
    const selectedDocId = selectedDoc?.document_id;
    handleRunPromptSpsApi(selectedDocId, token);
  };

  const handleRunPromptSpsApi = (docId, token) => {
    const body = {
      document_id: docId,
      sps_id: details?.tool_id,
      id: promptDetails?.prompt_id,
      recaptcha_token: token,
    };

    handleSpsLoading(docId, true);
    promptRunSps(body)
      .then(() => {
        handleGetOutput();
      })
      .catch((err) => {
        setAlertDetails(
          handleException(
            err,
            `Failed to generate output for ${selectedDoc?.document_id}`
          )
        );
      })
      .finally(() => {
        handleSpsLoading(docId, false);
      });
  };

  return (
    <>
      <Tooltip title="Run">
        <Button
          size="small"
          type="text"
          className="prompt-card-action-button"
          disabled={spsLoading[selectedDoc?.document_id]}
          onClick={promptRunValidation}
        >
          <PlayCircleOutlined className="prompt-card-actions-head" />
        </Button>
      </Tooltip>
      <RecaptchaModal
        open={openCaptchaModal}
        setOpen={setOpenCaptchaModal}
        onSuccess={handleRunPromptSps}
      />
    </>
  );
}

PromptRunBtnSps.propTypes = {
  spsLoading: PropTypes.object,
  handleSpsLoading: PropTypes.func.isRequired,
  handleGetOutput: PropTypes.func.isRequired,
  promptDetails: PropTypes.object.isRequired,
};

export { PromptRunBtnSps };
